import { subscribeOpenBotsCatalog, broadcastOpenBotsCatalog } from './openBotsCatalog';

export default {
  subscribeOpenBotsCatalog,
  broadcastOpenBotsCatalog,
};
